/**
 * Manual site suspension switch.
 *
 * true  -> the whole site is replaced by the suspension notice.
 * false -> the site works exactly as it did before.
 *
 * Two ways to control it:
 *  1. Flip SUSPENDED_DEFAULT below, commit and push (Vercel redeploys).
 *  2. Set the Vercel environment variable REACT_APP_SITE_SUSPENDED to
 *     "true" or "false" and redeploy. When that variable is set it wins
 *     over SUSPENDED_DEFAULT, so the site can be toggled from the Vercel
 *     dashboard without touching the code.
 *
 * Note: Create React App inlines env vars at build time, so either way a
 * redeploy is needed for the change to take effect.
 */

// Manual switch — change this to false to bring the site back online.
const SUSPENDED_DEFAULT = false;

const envFlag = process.env.REACT_APP_SITE_SUSPENDED;

export const SITE_SUSPENDED =
  envFlag === undefined || envFlag === ''
    ? SUSPENDED_DEFAULT
    : String(envFlag).trim().toLowerCase() === 'true';
